<template>
  <div class="wrapper">
    <div class="banner-content">
      <img class="title-icon" src="@/assets/img/mobile/icon-banner.webp" />
      <div class="title">
        <span class="name">Mureka</span>
        <span class="slogan"
          >{{ $$t("land.firTitle") }}, {{ $$t("land.firSubTitle") }}</span
        >
      </div>
      <div class="button" @click="downloadApp">
        {{ $$t("land.downloadApp") }}
      </div>
    </div>
  </div>
</template>

<script setup>
import CallApp from "callapp-lib";
import { isIos } from "@/utils/cookie";
import { $$language, $$t } from "@/i18n/i18n.js";

const emits = defineEmits(["download"]);

const props = defineProps({
  shareKey: {
    type: String,
    default: "",
  },
});

const callApp = ref();

const downloadApp = async () => {
  emits("download");
  if (!callApp.value) await initCallApp();
  callApp.value.open({
    path: `music/playerDetail?share_key=${props.shareKey}&is_from_share=1`,
    callback: () => {
      console.log("success");
      window.location.href = isIos()
        ? "https://apps.apple.com/us/app/mureka-ai/id6677033144"
        : "https://play.google.com/store/apps/details?id=ai.mureka.android";
    },
  });
};

async function initCallApp() {
  callApp.value = new CallApp({
    scheme: { protocol: "mureka", host: "mureka.ai" },
    // intent: { scheme: "mureka", package: "" },
    // universal: {
    //   host: 'tiangong.kunlun.com',
    // },
    timeout: 3000,
  });
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  height: 48px;
  z-index: 999;

  .banner-content {
    position: absolute;
    height: 48px;
    width: 100vw;

    left: -28px;
    top: -28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.1);

    backdrop-filter: blur(100px);
    color: #000000;
    padding: 9px 16px;
    font-size: 16px;
    font-weight: 500;

    .title {
      flex: 1;
      display: flex;
      flex-direction: column;
      color: #fff;
      .name {
        font-size: 14px;
        font-weight: bold;
        line-height: 16px;
      }
      .slogan {
        margin-top: 2px;
        font-size: 10px;
        font-weight: 500;
        line-height: 12px;
      }
    }

    .title-icon {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }

    .button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      padding: 9px 12px;
      border-radius: 60px;
      color: #000000;

      background: linear-gradient(107deg, #4fdeff 0%, #e675ff 100%);
    }
  }
}
</style>
